/// <amd-module name="Feed/Legacy/Actions/FeedSettings/GetScopedBuildPermission" />
import { IVssPageContext } from "VSS/Platform/Context";

import { FeedPermission, FeedRole } from "Feed/Common/Contracts/Feed";
import { FeedBuildIdentity } from "Feed/Common/Contracts/WebPage";
import { HubWebPageDataService } from "Feed/Legacy/DataServices/WebPageDataService";

/**
 * Gets Adds to the Contributors role the following identities, if they're not already present:
 *  1. Project Collection Build Service (isCollectionScope)
 *  2. Project Build Service (!isCollectionScope)
 */
export function GetScopedBuildPermission(pageContext: IVssPageContext, isCollectionScope: boolean): FeedPermission {
    const webPageDataService = pageContext.getService<HubWebPageDataService>("IFeedWebPageDataService");
    const identity: FeedBuildIdentity = isCollectionScope
        ? webPageDataService.getCollectionBuildIdentity()
        : webPageDataService.getProjectBuildIdentity();

    return {
        identityId: identity.id,
        identityDescriptor: identity.descriptor,
        displayName: identity.displayName,
        role: FeedRole.Contributor,
        isInheritedRole: false
    };
}
